module.exports = __webpack_public_path__ + "img/license-CC BY-NC-ND.2e0d274c.png";